/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Showcase_Recentunlockstitle2Inputs */

const id_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembukaan Terbaru`)
};

const ms_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukaan Terkini`)
};

const da_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste Oplåsninger`)
};

const de_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Freischaltungen`)
};

const en_us2_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent Unlocks`)
};

const es_es2_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueos recientes`)
};

const es_mx2_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueos recientes`)
};

const fil_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Kamakailang Unlock`)
};

const fr_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déblocages récents`)
};

const it_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocchi recenti`)
};

const hu_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legutóbbi feloldások`)
};

const nl_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recente ontgrendelingen`)
};

const no_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nylige opplåsinger`)
};

const pl_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie odblokowania`)
};

const pt_br2_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueios recentes`)
};

const pt_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desbloqueios recentes`)
};

const ro_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deblocări recente`)
};

const fi_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisimmät avaukset`)
};

const sv_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste upplåsningar`)
};

const vi_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mở khóa gần đây`)
};

const tr_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Açılımlar`)
};

const cs_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedávná odemčení`)
};

const bg_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скорошни отключвания`)
};

const ru_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недавние открытия`)
};

const uk_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні розблокування`)
};

const ar_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر عمليات الفتح`)
};

const hi_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाल के अनलॉक`)
};

const th_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การปลดล็อกล่าสุด`)
};

const ja_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近の解除`)
};

const zh_cn2_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近解锁`)
};

const zh_hant1_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近解鎖`)
};

const ko_profile_showcase_recentunlockstitle2 = /** @type {(inputs: Profile_Showcase_Recentunlockstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최근 잠금 해제`)
};

/**
* | output |
* | --- |
* | "Recent Unlocks" |
*
* @param {Profile_Showcase_Recentunlockstitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_showcase_recentunlockstitle2 = /** @type {((inputs?: Profile_Showcase_Recentunlockstitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Showcase_Recentunlockstitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "ms") return ms_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "da") return da_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "de") return de_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "en-US") return en_us2_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "es-ES") return es_es2_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "es-MX") return es_mx2_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "fil") return fil_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "fr") return fr_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "it") return it_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "hu") return hu_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "nl") return nl_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "no") return no_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "pl") return pl_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "pt") return pt_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "ro") return ro_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "fi") return fi_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "sv") return sv_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "vi") return vi_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "tr") return tr_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "cs") return cs_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "bg") return bg_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "ru") return ru_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "uk") return uk_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "ar") return ar_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "hi") return hi_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "th") return th_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "ja") return ja_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_showcase_recentunlockstitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_showcase_recentunlockstitle2(inputs)
	return ko_profile_showcase_recentunlockstitle2(inputs)
});
export { profile_showcase_recentunlockstitle2 as "profile.showcase.recentUnlocksTitle" }